export default __webpack_public_path__ + "static/media/matmopoly.239d4566.JPG";